import { FunctionComponent, useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import styles from '../customisation.module.scss'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import { DaycareGroupsUrl } from '@/types/DaycareGroup'
import { GET_DAYCARE_GROUP_URLS_FOR_DAYCARE } from '@/modules/API/daycareGroup/daycareGroupUrl'
import Loading from '@/components/Loading/Loading'
import { getDaycareGroupsIconTextToJSX } from '@/modules/helper/iconsHelper'

interface DaycareUrlProps {
    daycareId: number
}

const DaycareUrl: FunctionComponent<DaycareUrlProps> = ({ daycareId }) => {
    const { t } = useTranslation()

    const [daycareGroupUrls, setDaycareGroupUrls] = useState<Array<DaycareGroupsUrl>>([])

    const [getDaycareGroupUrlsForDaycare, { loading: loadingUrls, data: dataUrls }] = useLazyQuery(
        GET_DAYCARE_GROUP_URLS_FOR_DAYCARE,
        {
            variables: {
                daycareId: daycareId
            }
        }
    )

    useEffect(() => {
        if (dataUrls) {
            setDaycareGroupUrls(dataUrls.getDaycareGroupUrlsForDaycare)
        }
    }, [dataUrls])

    useEffect(() => {
        getDaycareGroupUrlsForDaycare()
    }, [daycareId])

    return (
        <>
            {loadingUrls && <Loading overall={false} />}
            {dataUrls && daycareGroupUrls.length > 0 && (
                <div className={styles.DaycareUrlPlacement}>
                    <div className={styles.Form}>
                        <div className={styles.TitleAndButton}>
                            <Title text={t('yourUrls')} className={styles.Title} />
                        </div>
                        <div className={styles.InputContainer}>
                            {daycareGroupUrls.map((url: DaycareGroupsUrl) => {
                                return (
                                    <a
                                        key={url.id}
                                        className={styles.Case}
                                        href={url.url}
                                        target={'_blank'}
                                        rel='noreferrer'
                                    >
                                        <div className={styles.CaseIcon}>
                                            {getDaycareGroupsIconTextToJSX(url.icon, styles.Icon)}
                                        </div>
                                        <div className={styles.CaseInfo}>
                                            <div className={styles.CaseTitle}>{url.text}</div>
                                            <div className={styles.CaseUrl}>{url.url}</div>
                                        </div>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default DaycareUrl
